import React, {useMemo} from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {useConstructionEndDate} from "../../../../property/hooks/useConstructionEndDate";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const ConstructionDateCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const {calculateConstructionEndDate} = useConstructionEndDate();
    const constructionDate = useMemo(() => {
        return calculateConstructionEndDate(property.construction_end_date, property.offer.construction_date_range);
    }, [property.construction_end_date, property.offer.construction_date_range, calculateConstructionEndDate]);

    return <>{constructionDate}</>;
};
import React, {useMemo} from "react";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {useConstructionEndDate} from "../../../../property/hooks/useConstructionEndDate";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const ConstructionDateCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const {calculateConstructionEndDate} = useConstructionEndDate();
    const constructionDate = useMemo(() => {
        return calculateConstructionEndDate(property.construction_end_date, property.offer.construction_date_range);
    }, [property.construction_end_date, property.offer.construction_date_range, calculateConstructionEndDate]);

    return <>{constructionDate}</>;
};
